import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

const Row = props => {
  const { children, className } = props;

  return (
    // <div className={cn("responsive-table__row", className)}>{children}</div>
    <tr className={cn("responsive-table__row", className)}>{children}</tr>
  );
};

Row.propsType = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Row;



// WEBPACK FOOTER //
// ./src/containers/responsive-table/row.js